import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import messages from '../../../locale/jsonMessages';
import { buildTimeline } from '../../../helpers/inspectionPresentation';
import ins from '../../Inspection/Inspection.css';
import s from './InspectionAdmin.css';

const MARK = { ok: '✓', danger: '!', pending: '○' };
const when = (value, locale) => (value ? new Date(value).toLocaleString(locale, { dateStyle: 'short', timeStyle: 'short' }) : '');

// Lifecycle of a reservation (R13, M5): Booked, Check-in, In progress, Check-out, Damage declared, Dispute, Closed.
export function InspectionTimeline({ reservation, checkin, checkout, dispute }) {
  const { formatMessage, locale } = useIntl();
  const steps = buildTimeline({ reservation, checkin, checkout, dispute });
  return (
    <ol className={s.timeline} aria-label={formatMessage(messages.inspAdmTimelineTitle)}>
      {steps.map((step) => (
        <li key={step.key} className={s.timelineStep}>
          <span className={cx(s.timelineDot, step.tone === 'danger' && s.dotDanger, step.tone === 'pending' && s.dotPending)} aria-hidden="true">{MARK[step.tone]}</span>
          <p className={s.timelineLabel}>{formatMessage(messages[step.key])}</p>
          <p className={s.timelineDate}>{step.at ? when(step.at, locale) : formatMessage(step.tone === 'pending' ? messages.inspAdmStepPending : messages.inspAdmStepDone)}</p>
        </li>
      ))}
    </ol>
  );
}

InspectionTimeline.propTypes = { reservation: PropTypes.object, checkin: PropTypes.object, checkout: PropTypes.object, dispute: PropTypes.object };

export default withStyles(ins, s)(InspectionTimeline);
